var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import styles from '../../@patternfly/patternfly-next/layouts/Page/page.css.js';
import { css } from '@patternfly/react-styles';
import { global_breakpoint_md as breakpointMd } from '@patternfly/react-tokens';
import PropTypes from 'prop-types';
import { debounce } from '../../internal/util';

export var PageLayouts = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};

var propTypes = {
  /** Content rendered inside the main section of the page layout (e.g. <PageSection />) */
  children: PropTypes.node,
  /** Additional classes added to the page layout */
  className: PropTypes.string,
  /** Header component (e.g. <PageHeader />) */
  header: PropTypes.node,
  /** Sidebar component for a side nav (e.g. <PageSidebar />) */
  sidebar: PropTypes.node,
  /** enable condensed header on scroll feature (for desktop only). Adjusts the height on scroll of the page header and horizontal nav. */
  useCondensed: PropTypes.bool,
  /** condensed height override */
  scrollingDistance: PropTypes.number
};

var defaultProps = {
  children: null,
  className: '',
  header: null,
  sidebar: null,
  useCondensed: false,
  scrollingDistance: 20
};

export var PageContext = React.createContext();

var Page = function (_React$Component) {
  _inherits(Page, _React$Component);

  function Page(props) {
    _classCallCheck(this, Page);

    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));

    _initialiseProps.call(_this);

    _this.mainRef = React.createRef();

    _this.state = {
      isTall: _this.isTall(props)
    };
    return _this;
  }

  _createClass(Page, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var useCondensed = this.props.useCondensed;

      if (useCondensed) {
        // I picked this because it's approx 1 frame (ie: 16.7ms)
        this.mainRef.current.addEventListener('scroll', debounce(this.handleScroll, 16));
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var useCondensed = this.props.useCondensed;

      if (useCondensed) {
        this.mainRef.current.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
      }
    }

    // only enable tall header if the user is using the `useCondensed` header feature and we are on desktop

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          header = _props.header,
          sidebar = _props.sidebar,
          useCondensed = _props.useCondensed,
          scrollingDistance = _props.scrollingDistance,
          rest = _objectWithoutProperties(_props, ['className', 'children', 'header', 'sidebar', 'useCondensed', 'scrollingDistance']);

      var isTall = this.state.isTall;


      return React.createElement(
        PageContext.Provider,
        { value: { isTall: isTall } },
        React.createElement(
          'div',
          _extends({}, rest, { className: css(styles.page, className) }),
          header,
          sidebar,
          React.createElement(
            'main',
            { ref: this.mainRef, role: 'main', className: css(styles.pageMain) },
            children
          )
        )
      );
    }
  }]);

  return Page;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.isTall = function (props) {
    return props.useCondensed && typeof window !== 'undefined' && window.innerWidth >= parseInt(breakpointMd.value, 10);
  };

  this.handleResize = function () {
    _this2.setState({ isTall: _this2.isTall(_this2.props) });
  };

  this.handleScroll = function (e) {
    var scrollingDistance = _this2.props.scrollingDistance;
    var isTall = _this2.state.isTall;

    if (_this2.isTall(_this2.props)) {
      window.requestAnimationFrame(function () {
        var main = e.target;
        var mainPosition = main.scrollTop;
        if (mainPosition > scrollingDistance && isTall) {
          _this2.setState({ isTall: false });
        } else if (mainPosition < scrollingDistance && !isTall) {
          _this2.setState({ isTall: true });
        }
      });
    }
  };
};

Page.propTypes = propTypes;
Page.defaultProps = defaultProps;

export default Page;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/layouts/Page/Page.js
// module id = 71
// module chunks = 0